import React from 'react';
import classnames from 'classnames';
import SVG, { SVGProps } from './SVGWrapper';

const GoogleIcon = ({ width = 12, height = 12, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('integration-icon', props.className)}
    viewBox="0 0 12 12"
  >
    <path
      stroke="none"
      d="M6.08,4.81 L6.08,7.19 C6.08,7.19 8.42,7.19 9.37,7.19 C8.86,8.73 8.06,9.56 6.08,9.56 C4.09,9.56 2.53,7.97 2.53,6 C2.53,4.03 4.09,2.44 6.08,2.44 C7.14,2.44 7.82,2.8 8.45,3.31 C8.95,2.82 8.91,2.75 10.18,1.56 C9.1,0.59 7.66,0 6.08,0 C2.72,0 0,2.69 0,6 C0,9.31 2.72,12 6.08,12 C11.11,12 12.33,7.69 11.93,4.81 L6.08,4.81 L6.08,4.81 Z"
    />
  </SVG>
);

const GoogleAltIcon = ({ width = 12, height = 12, ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height }}
    className={classnames('integration-icon', props.className)}
    viewBox="0 0 18 18"
  >
    <g fill="none" fillRule="evenodd" stroke="none">
      <path
        d="M.99 4.965c.375-.808.904-1.513 1.525-2.15C3.92 1.372 5.62.448 7.635.133c2.818-.441 5.34.21 7.52 2.049.137.116.171.184.022.328-.77.738-1.527 1.488-2.288 2.234-.079.077-.131.17-.27.045-1.92-1.723-5.052-1.703-7.09.155a5.731 5.731 0 0 0-1.525 2.28c-.047-.031-.097-.059-.142-.092L.99 4.965"
        fill="#D7282A"
      />
      <path
        d="M3.982 10.742c.275.684.617 1.332 1.125 1.881C6.399 14.021 8 14.624 9.919 14.43c.89-.09 1.703-.386 2.462-.84.073.063.142.131.219.19.888.68 1.777 1.357 2.666 2.036a7.681 7.681 0 0 1-3.44 1.842c-3.07.76-5.899.28-8.412-1.663a8.39 8.39 0 0 1-2.432-2.97l3-2.282"
        fill="#45AC43"
      />
      <path
        d="M15.266 15.815 12.6 13.779c-.077-.059-.146-.127-.219-.19.602-.451 1.104-.983 1.434-1.66.132-.27.224-.552.311-.837.06-.197.042-.273-.206-.271-1.48.012-2.96.006-4.44.006-.313 0-.313 0-.313-.318 0-.983.005-1.965-.004-2.948-.002-.19.032-.262.25-.262 2.729.008 5.458.007 8.187.003.147 0 .24.01.266.186.34 2.339.067 4.573-1.182 6.637-.383.632-.842 1.21-1.418 1.69"
        fill="#5D7FBE"
      />
      <path
        d="m3.982 10.742-3 2.282c-.488-.89-.77-1.845-.9-2.84A8.733 8.733 0 0 1 .85 5.217c.041-.087.093-.169.14-.253l2.872 2.167c.045.033.095.06.142.091-.4 1.17-.38 2.344-.022 3.519"
        fill="#F4C300"
      />
    </g>
  </SVG>
);

export const AppleIcon = ({ width = 12, height = 12, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('integration-icon apple-icon', props.className)}
    viewBox="0 0 16 21"
  >
    <path
      stroke="none"
      d="M11.597 4.594c-.49 0-.951.071-1.383.214-.431.143-.82.288-1.167.435-.347.147-.652.22-.914.22-.27 0-.573-.069-.907-.208a21.476 21.476 0 0 0-1.072-.41 3.623 3.623 0 0 0-1.218-.202c-.812 0-1.597.214-2.354.643-.757.429-1.377 1.062-1.859 1.899S0 9.057 0 10.29c0 1.152.2 2.293.603 3.424.401 1.131.886 2.089 1.453 2.873.49.661.968 1.229 1.433 1.702.466.474 1.007.711 1.624.711.406 0 .76-.065 1.06-.196.3-.13.617-.261.952-.392.334-.13.75-.196 1.25-.196.515 0 .926.063 1.23.19.305.126.6.253.888.38.288.126.656.19 1.104.19.668 0 1.241-.246 1.72-.736.477-.49.924-1.024 1.338-1.604.474-.67.814-1.278 1.021-1.826.208-.547.316-.837.324-.87a56.885 56.885 0 0 1-.425-.22c-.267-.139-.571-.357-.914-.655-.342-.298-.642-.692-.9-1.182s-.387-1.087-.387-1.789c0-.612.101-1.141.304-1.586.203-.445.44-.813.71-1.103.271-.29.517-.51.737-.661.22-.151.342-.24.367-.264-.44-.612-.928-1.051-1.465-1.317-.537-.265-1.03-.426-1.478-.483a8.72 8.72 0 0 0-.952-.086ZM10.9 3.038c.305-.36.554-.77.749-1.231A3.64 3.64 0 0 0 11.94.38c0-.147-.013-.274-.038-.38-.491.016-1.007.16-1.548.429-.542.27-.99.608-1.345 1.017-.28.302-.529.683-.749 1.145-.22.461-.33.937-.33 1.427 0 .074.004.143.013.208a.79.79 0 0 0 .025.135c.085.016.174.025.267.025.448 0 .922-.13 1.42-.386a4.08 4.08 0 0 0 1.244-.962Z"
    />
  </SVG>
);

export const MicrosoftIcon = ({
  width = 12,
  height = 12,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('integration-icon microsoft-icon', props.className)}
    viewBox="-0.1 -0.1 12 12"
  >
    <defs>
      <clipPath id="msftRect">
        <rect x="0" y="0" width="11.8" height="11.8" rx="0.4" />
      </clipPath>
    </defs>
    <g clipPath="url(#msftRect)" stroke="none">
      <rect x="0" y="0" width="5.5" height="5.5"></rect>
      <rect x="6.3" y="0" width="5.5" height="5.5"></rect>
      <rect x="6.3" y="6.3" width="5.5" height="5.5"></rect>
      <rect x="0" y="6.3" width="5.5" height="5.5"></rect>
    </g>
  </SVG>
);

export const Twitter = ({ width = 12, height = 10, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('integration-icon twitter-icon', props.className)}
    viewBox="0 0 12 10"
  >
    <path
      stroke="none"
      d="M12,1.18 C11.56,1.38 11.08,1.52 10.59,1.58 C11.09,1.27 11.49,0.77 11.67,0.18 C11.19,0.47 10.67,0.68 10.1,0.8 C9.66,0.31 9.02,0 8.31,0 C6.95,0 5.85,1.13 5.85,2.52 C5.85,2.72 5.87,2.91 5.91,3.1 C3.86,2.99 2.05,1.99 0.84,0.46 C0.62,0.83 0.5,1.27 0.5,1.73 C0.5,2.61 0.94,3.38 1.6,3.83 C1.19,3.82 0.81,3.71 0.48,3.52 L0.48,3.55 C0.48,4.77 1.33,5.79 2.46,6.02 C2.25,6.08 2.03,6.11 1.81,6.11 C1.65,6.11 1.5,6.1 1.35,6.07 C1.66,7.07 2.57,7.8 3.65,7.82 C2.8,8.5 1.74,8.9 0.59,8.9 C0.39,8.9 0.19,8.89 0,8.87 C1.09,9.58 2.38,10 3.77,10 C8.3,10 10.78,6.15 10.78,2.82 C10.78,2.71 10.78,2.6 10.77,2.49 C11.25,2.13 11.67,1.69 12,1.18"
    />
  </SVG>
);

const DesktopIcon = ({ width = 24, height = 16, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('desktop-icon', props.className)}
    viewBox="0 0 24 16"
  >
    <path
      stroke="none"
      d="M8.6,13.5 C8.8,13.5 9,13.6 9,13.8 L9,13.9 C9,14.1 9.2,14.3 9.4,14.3 L13.7,14.3 C13.9,14.3 14.1,14.2 14.1,14 L14.1,13.9 C14.1,13.7 14.3,13.5 14.6,13.5 L23.6,13.5 C23.8,13.5 24,13.7 24,13.9 L24,14.7 C24,15.4 23.4,16 22.7,16 L1.3,16 C0.6,16 0,15.4 0,14.7 L0,13.9 C0,13.7 0.2,13.5 0.4,13.5 L8.6,13.5 Z M19.3,0 C20.5,0 21.4,0.9 21.4,2.1 L21.4,12.2 C21.4,12.4 21.2,12.6 21,12.6 L3,12.6 C2.8,12.6 2.6,12.4 2.6,12.2 L2.6,2.1 C2.6,0.9 3.5,0 4.7,0 L19.3,0 Z M19,1.5 L5,1.5 C4.4,1.5 4,1.9 4,2.5 L4,2.5 L4,11 L20,11 L20,2.5 C20,1.9 19.6,1.5 19,1.5 L19,1.5 Z"
    />
  </SVG>
);

export const DesktopAltIcon = ({
  width = 16,
  height = 14,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('desktop-alt-icon', props.className)}
    viewBox="0 0 16 14"
  >
    <path
      fill="none"
      d="M14 10V3C14 1.9 13.1 1 12 1H4C2.9 1 2 1.9 2 3V10 M15.5 11.5V10.5C15.5 10.2 15.3 10 15 10H10.8H1C0.7 10 0.5 10.2 0.5 10.5V11.5C0.5 12.3 1.2 13 2 13H14C14.8 13 15.5 12.3 15.5 11.5ZM6 1.5H10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVG>
);

const PhoneIcon = ({ width = 11, height = 18, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('phone-icon', props.className)}
    viewBox="0 0 11 18"
  >
    <path
      stroke="none"
      d="M9.2,0 C10.2,0 11,0.8 11,1.875 L11,16.125 C11,17.2 10.2,18 9.2,18 L1.8,18 C0.8,18 0,17.2 0,16.125 L0,1.875 C0,0.8 0.8,0 1.8,0 L9.2,0 Z M5.5,15 C4.9,15 4.4,15.5 4.4,16.125 C4.4,16.7 4.9,17.25 5.5,17.25 C6.1,17.25 6.6,16.7 6.6,16.125 C6.6,15.5 6.1,15 5.5,15 Z M8.4,1.125 L2.6,1.125 C1.8,1.125 1.1,1.8 1.1,2.625 L1.1,2.625 L1.1,13.125 C1.1,13.5 1.4,13.875 1.85,13.875 L1.85,13.875 L9.15,13.875 C9.6,13.875 9.9,13.5 9.9,13.125 L9.9,13.125 L9.9,2.625 C9.9,1.8 9.2,1.125 8.4,1.125 L8.4,1.125 Z"
    />
  </SVG>
);

// map of integration icons
export default {
  'apple': AppleIcon,
  'google': GoogleIcon,
  'googleAlt': GoogleAltIcon,
  'microsoft': MicrosoftIcon,
  'twitter-platforms': Twitter,
  'twitter': Twitter,
  'desktop': DesktopIcon,
  'phone': PhoneIcon,
};
